import { render } from "./ConfigApp.vue?vue&type=template&id=53f9d863&scoped=true&ts=true"
import script from "./ConfigApp.vue?vue&type=script&lang=ts"
export * from "./ConfigApp.vue?vue&type=script&lang=ts"

import "./ConfigApp.vue?vue&type=style&index=0&id=53f9d863&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f9d863"]])

export default __exports__